// generated by genversion
export var version = '3.8.12';
//# sourceMappingURL=version.js.map